import { render, staticRenderFns } from "./ItAudit.vue?vue&type=template&id=e28b2322&scoped=true"
import script from "./ItAudit.vue?vue&type=script&lang=ts"
export * from "./ItAudit.vue?vue&type=script&lang=ts"
import style0 from "./ItAudit.vue?vue&type=style&index=0&id=e28b2322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28b2322",
  null
  
)

export default component.exports